import { fileOf, rankOf } from "./board";
import type { Board, Square } from "./types";

function squareColorParity(square: Square): number {
  return (fileOf(square) + rankOf(square)) % 2;
}

/** Nulle par materiel insuffisant : plus aucune combinaison de pieces restantes ne peut forcer un mat. */
export function isInsufficientMaterial(board: Board): boolean {
  const nonKing: { type: string; square: Square }[] = [];
  board.forEach((piece, square) => {
    if (piece && piece.type !== "k") nonKing.push({ type: piece.type, square });
  });

  if (nonKing.length === 0) return true; // roi contre roi
  if (nonKing.length === 1) {
    const [only] = nonKing;
    return only?.type === "n" || only?.type === "b"; // roi + mineure contre roi
  }
  if (nonKing.length === 2 && nonKing.every((p) => p.type === "b")) {
    const [a, b] = nonKing as [{ type: string; square: Square }, { type: string; square: Square }];
    return squareColorParity(a.square) === squareColorParity(b.square); // fous de meme couleur de case
  }
  return false;
}
